module.exports = __webpack_public_path__ + "media/images/icons/facebook-white-4fa294b11372553c8531b86bfb31a939.svg";